/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weighing_Filter_All_GrowersInputs */

const vi_weighing_filter_all_growers = /** @type {(inputs: Weighing_Filter_All_GrowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả hộ`)
};

/**

* @param {Weighing_Filter_All_GrowersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const weighing_filter_all_growers = /** @type {((inputs?: Weighing_Filter_All_GrowersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weighing_Filter_All_GrowersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_weighing_filter_all_growers(inputs)
});